import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { templatesApi } from '../services/templatesApi'

export const useTemplates = (applicationId) => {
  return useQuery({
    queryKey: ['templates', applicationId],
    queryFn: () => templatesApi.getByApplication(applicationId),
    enabled: !!applicationId,
  })
}

export const useTemplate = (id) => {
  return useQuery({
    queryKey: ['template', id],
    queryFn: () => templatesApi.getById(id),
    enabled: !!id,
  })
}

export const useCreateTemplate = (applicationId) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data) => templatesApi.create(applicationId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['templates', applicationId] })
    },
  })
}

export const useUpdateTemplate = (applicationId) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, data }) => templatesApi.update(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['template', variables.id] })
      queryClient.invalidateQueries({ queryKey: ['templates', applicationId] })
    },
  })
}

export const useDeleteTemplate = (applicationId) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id) => templatesApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['templates', applicationId] })
    },
  })
}

export const useTemplateFiles = (templateId) => {
  return useQuery({
    queryKey: ['template-files', templateId],
    queryFn: () => templatesApi.listFiles(templateId),
    enabled: !!templateId,
  })
}

export const useUploadTemplateFiles = (templateId, applicationId) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (files) => templatesApi.uploadFiles(templateId, files),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['template-files', templateId] })
      queryClient.invalidateQueries({ queryKey: ['templates', applicationId] })
    },
  })
}

export const useDeleteTemplateFile = (templateId) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (filename) => templatesApi.deleteFile(templateId, filename),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['template-files', templateId] })
    },
  })
}
